module.exports = __webpack_public_path__ + "static/media/Tooth_icon_b605d5.89fe745f.svg";